import { KEYS } from "@/domain/keys";
import { QuestionMetricsPayload } from "@/domain/model/question_metrics";

const setStorageQuestionMetrics = (data: QuestionMetricsPayload) => {
  window.localStorage.setItem(KEYS.USER_QUESTION_METRICS, JSON.stringify(data));
};

const getStorageQuestionMetrics = () => {
  return JSON.parse(
    window.localStorage.getItem(KEYS.USER_QUESTION_METRICS) ?? "{}",
  ) as QuestionMetricsPayload;
};

const removeStorageQuestionMetrics = () => {
  window.localStorage.removeItem(KEYS.USER_QUESTION_METRICS);
};

export const storageQuestionMetrics = {
  set: setStorageQuestionMetrics,
  get: getStorageQuestionMetrics,
  remove: removeStorageQuestionMetrics,
};
